export default __webpack_public_path__ + "static/media/pictogramBeaconShares40.4b82c660.svg";